import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

const VideoPlayer = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  // Get the 'url' query parameter
  const videoUrl = searchParams.get("url");

  if (!videoUrl) {
    return (
      <div style={styles.container}>
        <h2 style={{ color: "white" }}>No video URL provided.</h2>
        <button onClick={() => navigate(-1)} style={styles.backButton}>Go Back</button>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Header / Back Button */}
      <div style={styles.header}>
        <button onClick={() => navigate(-1)} style={styles.backButton}>
          ← Back
        </button>
        <span style={styles.title}>Surveillance Evidence Playback</span>
      </div>

      {/* Video Container */}
      <div style={styles.videoWrapper}>
        <video 
          controls 
          autoPlay 
          style={styles.video} 
          src={videoUrl}
        >
          Your browser does not support the video tag.
        </video>
      </div>

      <div style={styles.footer}>
        <p>Source: {videoUrl}</p>
      </div>
    </div>
  );
};

// ... keep your existing styles ...
const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    backgroundColor: "#1a1a1a",
    color: "#fff",
    fontFamily: "Arial, sans-serif",
  },
  header: {
    position: "absolute",
    top: 20,
    left: 20,
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    gap: "15px",
  },
  backButton: {
    background: "rgba(255, 255, 255, 0.2)",
    border: "none",
    color: "white",
    padding: "10px 20px",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "16px",
  },
  title: {
    fontSize: "18px",
    opacity: 0.8,
  },
  videoWrapper: {
    width: "80%",
    maxWidth: "1000px",
    boxShadow: "0px 0px 20px rgba(0,0,0,0.5)",
  },
  video: {
    width: "100%",
    borderRadius: "8px",
    backgroundColor: "#000",
  },
  footer: {
    marginTop: "20px",
    fontSize: "12px",
    opacity: 0.5,
    wordBreak: "break-all",
    maxWidth: "80%",
    textAlign: "center",
  },
};

export default VideoPlayer;